if (typeof boostPFSThemeConfig !== 'undefined') {
  // Override Settings
  var boostPFSFilterConfig = {
    general: {
      limit: boostPFSThemeConfig.custom.products_per_page,
      loadProductFirst: false,
      numberFilterTree: 2,
      showPlaceholderProductList: false,
      placeholderProductPerRow: 4,
      placeholderProductGridItemClass: 'Grid__Cell 1/' + boostPFSThemeConfig.custom.mobile_row + '--phone 1/' + boostPFSThemeConfig.custom.tablet_row + '--tablet-and-up 1/' + boostPFSThemeConfig.custom.desktop_row,
      requestInstantly: true,
      getCollectionPriceStatus: boostPFSThemeConfig.custom.collection_price_status
    }
  };
  // Declare Templates
  var boostPFSTemplate = {
    // Grid Template
    'productGridItemHtml': '<div class="Grid__Cell 1/' + boostPFSThemeConfig.custom.mobile_row + '--phone 1/' + boostPFSThemeConfig.custom.tablet_row + '--tablet-and-up 1/' + boostPFSThemeConfig.custom.desktop_row + '--{{buildClass}}">' +
      '<div class="ProductItem {{buildClassHiz}}">' +
      '<div class="ProductItem__Wrapper bc-sf-filter">' +
      '{{itemImages}}' +
      '{{itemLabels}}' +
      '{{itemInfo}}' +
      '</div>' +
      '{{itemFlairHtml}}' +
      '{{buildButtonSecond}}' +
      '</div>' +
      '</div>',
    // Pagination Template
    'previousActiveHtml': '<a class="Pagination__NavItem Link Link--primary" rel="prev" href="{{itemUrl}}" aria-label="Previous page"><svg class="{{ icon_class }}" role="presentation" viewBox="0 0 11 18"><path d="M9.5 1.5L1.5 9l8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path></svg></a>',
    'previousDisabledHtml': '',
    'nextActiveHtml': '<a class="Pagination__NavItem Link Link--primary" rel="next" href="{{itemUrl}}" aria-label="Next page"><svg class="{{ icon_class }}" role="presentation" viewBox="0 0 11 18"><path d="M1.5 1.5l8 7.5-8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path> </svg></a>',
    'nextDisabledHtml': '',
    'pageItemHtml': '<a class="Pagination__NavItem Link Link--primary" href="{{itemUrl}}" aria-label="Page {{itemTitle}}">{{itemTitle}}</a>',
    'pageItemSelectedHtml': '<span class="Pagination__NavItem is-active" aria-label=" Page {{itemTitle}}"aria-current="page" tabindex="0">{{itemTitle}}</span>',
    'pageItemRemainHtml': '<span class="Pagination__NavItem" aria-label="Page {{itemTitle}}">{{itemTitle}}</span>',
    'paginateHtml': ' <div class="Pagination Text--subdued"><div class="Pagination__Nav">{{previous}}{{pageItems}}{{next}}</div></div>',
    // Sorting Template
    'sortingHtml': '{{sortingItems}}',
  };
}

var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
var array = [];

(function () {
  BoostPFS.inject(this);
  /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  function prepareShopifyData(data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    images = data.images_info; // Convert images to array
    var firstVariant = data['variants'][0]; // Get First Variant (selected_or_first_available_variant)
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function (e) { return e.id == Utils.getParam('variant'); });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      firstVariant = data['variants'].find(variant => variant.available);
    }

    /* ====== Build a lookup map from hide_product_option_values metafield ======
       ====== Skip variants with certain tags and conditions ====== */
    var hideOptionValuesMap = {};
    
    var hideMetafield = data.metafields
      ? data.metafields.find(function(m) { return m.key === 'hide_product_option_values'; })
      : null;
    if (hideMetafield && hideMetafield.value) {
      try {
        hideOptionValuesMap = JSON.parse(hideMetafield.value);
        // Normalize all keys/values to lowercase for consistent comparison
        Object.keys(hideOptionValuesMap).forEach(function(optionName) {
          var normalizedKey = optionName.toLowerCase();
          hideOptionValuesMap[normalizedKey] = (hideOptionValuesMap[optionName] || []).map(function(v) {
            return v.toLowerCase();
          });
          if (normalizedKey !== optionName) delete hideOptionValuesMap[optionName];
        });
      } catch(e) {
        hideOptionValuesMap = {};
      }
    }

    data.variants = data.variants.filter(function (variant) {
      // Check hide_product_option_values metafield — mirrors PDP Liquid logic
      if (variant.merged_options && Object.keys(hideOptionValuesMap).length > 0) {
        var shouldHide = variant.merged_options.some(function(mergedOpt) {
          var parts = mergedOpt.split(':');
          if (parts.length < 2) return false;
          var optionName = parts[0].trim().toLowerCase();
          var optionValue = parts.slice(1).join(':').trim().toLowerCase();
          return hideOptionValuesMap[optionName] &&
                hideOptionValuesMap[optionName].indexOf(optionValue) !== -1;
        });
        if (shouldHide) return false;
      }

      // Existing metal/color tag-based hiding
      var temp = variant.merged_options.filter(function (obj) {
        obj = obj.toLowerCase();
        if (obj.indexOf('metal') != -1 || obj.indexOf('color') != -1 || obj.indexOf('colour') != -1)
          return obj;
      });
      if (temp.length > 0) {
        temp = temp[0].split(':');
        var value = temp[1].toLowerCase();
        var hideRoseGold = value == '14k rose gold' && data.tags.includes('hide-rose-gold-variants');
        return !hideRoseGold;
      }
      return true;
    });

    var variantArr = '';
    if (Globals.queryParams.hasOwnProperty('pf_st_only_see_in_stock')) {
      variantArr = data.variants.filter(function (e) {
        return e.available;
      })
      if (typeof variantArr[0] === 'undefined') variantArr = data.variants;
    }

    if (Globals.queryParams.hasOwnProperty('pf_opt_metal')) {
      var variantNamesArr = []
      for (var variant of variantArr) {
        var size = variant['option_metal'];
        if (variant.merged_options) {
          for (var option of variant.merged_options) {
            if (option.includes('metal:')) {
              variantNamesArr.push(option.replace(/metal:/g, '').replace(/ /g, ''));
            }
          }
        }
        if (Globals.queryParams['pf_opt_metal'].indexOf(size) >= 0) {
          selectedVariant = variant;
          break;
        }
      }
      if (selectedVariant.image) {
        var idx = images.findIndex(i => i.src === selectedVariant.image);
        var newImages = images.filter(i => i.src !== selectedVariant.image);
        var secondImage = images[images.length - 2];
        // Construct the new images array
        images = secondImage ? [images[idx], secondImage, ...newImages] : [images[idx], ...newImages];
      }
    }
    return data;
  }
  /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/

  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data, index) {
    data = data || this.data;
    index = index || this.index;
    
    /* ============ Collection Dynamic Content Block Integration: Injecting block on specific positions ============ */
    var currentPage = parseInt(getParameterByName("page") || "1");
    var showContentTogether = boostPFSThemeConfig.custom.blockContentShowTogether;
    var grabBlockContentData = boostPFSThemeConfig.custom.blockContent;
    var promoTileHtml = '';

    // Only run once at the base index — where the first tile starts
    if (grabBlockContentData && grabBlockContentData !== "") {
      const promoTilesContent = JSON.parse(grabBlockContentData);
      const isFirstPage = currentPage === 1;
    
      if (promoTilesContent && isFirstPage) {
        const currentPosition = index + 1;
    
        if (showContentTogether === 'true') {
          const allPositions = promoTilesContent.map(tile => tile.position);
          const minPosition = Math.min(...allPositions);
    
          if (currentPosition === minPosition) {
            const sortedTiles = promoTilesContent
              .filter(tile => tile.position >= currentPosition)
              .sort((a, b) => a.position - b.position);
    
            sortedTiles.forEach(promoTile => {
              const isVideo = promoTile.video && promoTile.video.trim() !== '';
              const mediaElement = isVideo
                ? `<video class="ProductItem__Video" autoplay muted loop playsinline>
                    <source src="${promoTile.video}" type="video/mp4">
                  </video>`
                : `<img loading="lazy" src="${promoTile.image}" alt="${promoTile.title}" class="ProductItem__Image imgfade" style="width: 100%; height: auto;" />`;
    
              promoTileHtml += generatePromoTileHTML(promoTile, mediaElement);
            });
          }
    
        } else {
          const promoTile = promoTilesContent.find(tile => tile.position === currentPosition);
          if (promoTile && (promoTile.image || promoTile.video)) {
            const isVideo = promoTile.video && promoTile.video.trim() !== '';
            const mediaElement = isVideo
              ? `<video class="ProductItem__Video" width="480" height="320" autoplay muted loop playsinline>
                  <source src="${promoTile.video}" type="video/mp4">
                  <track kind="captions">
                </video>`
              : `<img loading="lazy" src="${promoTile.image}" alt="${promoTile.title}" class="ProductItem__Image imgfade" style="width: 100%; height: auto;" />`;
    
            promoTileHtml = generatePromoTileHTML(promoTile, mediaElement);
          }
        }
      }
    }
    
    // Extracted common HTML generation into a function
    function generatePromoTileHTML(promoTile, mediaElement) {
      return `
        <div class="Grid__Cell_Custom 1/${boostPFSThemeConfig.custom.mobile_row}--phone 1/${boostPFSThemeConfig.custom.tablet_row}--tablet-and-up 1/${boostPFSThemeConfig.custom.desktop_row}--${buildClass()}">
          <div class="ProductItem ${buildClassHiz()}">
            <div class="ProductItem__Wrapper bc-sf-filter cb-space-manage-mobile">
              <a href="${promoTile.cta_url || 'javascript:void(0)'}" class="ProductItem__ImageWrapper promo-link" style="cursor: ${promoTile.cta_url ? 'pointer' : 'default'};">
                ${mediaElement}
              </a>
              <div class="ProductItem__Info">
                ${promoTile.title ? `<span class="promo-heading">${promoTile.title}</span>` : ''}
                ${promoTile.cta_title && promoTile.cta_url ? `
                  <h3 class="ProductItem__Title promo-title Heading u-h6">
                    <a class="promo-cta-link" href="${promoTile.cta_url}">${promoTile.cta_title}</a>
                  </h3>` : ''}
              </div>
            </div>
          </div>
        </div>
      `;
    }

    // Get template and prepare Shopify data
    let itemHtml = boostPFSTemplate.productGridItemHtml;
    data = prepareShopifyData(data);

    // Find the first in-stock variant
    const getFirstInStockVariant = data.variants.find(variant => variant.inventory_quantity > 0);

    // Replace placeholders in template
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data))
      .replace(/{{mobileRow}}/g, boostPFSConfig.custom.mobile_row)
      .replace(/{{tabletRow}}/g, boostPFSConfig.custom.tablet_row)
      .replace(/{{desktopRow}}/g, boostPFSConfig.custom.desktop_row)
      .replace(/{{itemImages}}/g, buildImage(data, images))
      .replace(/{{itemInfo}}/g, buildInfo(data, index))
      .replace(/{{itemFlairHtml}}/g, `<div data-flair-product-badge data-product-id="${data.id}"></div>`)
      .replace(/{{buildClassHiz}}/g, buildClassHiz())
      .replace(/{{buildClass}}/g, buildClass())
      .replace(/{{buildButtonSecond}}/g, buildButtonSecond())
      .replace(/{{itemReviews}}/g, (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) ? '' : '');

    // Select a variant based on query params if applicable
    let selectedVariant = null;
    if (Globals.queryParams.pf_opt_metal) {
      selectedVariant = data.variants.find(variant => Globals.queryParams.pf_opt_metal.includes(variant.option_metal));
    }
    if (!selectedVariant && Globals.queryParams.pf_opt_size) {
      selectedVariant = data.variants.find(variant => variant.inventory_policy === "continue" && Globals.queryParams.pf_opt_size.includes(variant.option_size)) || undefined;
    }
    if(selectedVariant === undefined){
      selectedVariant = getFirstInStockVariant;
    }

    // Handle variant redirection logic
    const redirectProductToSpecificVariant = Utils.getProductMetafield(data, 'custom', 'product_redirect');
    /* Redirect to Black Variant instead of Cream: Multiway Leather Jewelry Case */
    if (redirectProductToSpecificVariant && redirectProductToSpecificVariant === '40239946039384') {
      itemHtml = itemHtml.replace(/{{itemUrl}}/g, `/products/multiway-leather-jewelry-case?Color=Black`);
    }
    /* Redirect to Black Variant instead of Cream: Mini Leather Jewelry Case */
    if (redirectProductToSpecificVariant && redirectProductToSpecificVariant === '40660565524568') {
      itemHtml = itemHtml.replace(/{{itemUrl}}/g, `/products/mini-leather-jewelry-case?Color=Black`);
    }
    if (getFirstInStockVariant && !Globals.queryParams.pf_opt_size && !Globals.queryParams.pf_opt_metal) {
      var variantId = redirectProductToSpecificVariant || getFirstInStockVariant.id;
      itemHtml = itemHtml.replace(/{{itemUrl}}/g, `${Utils.buildProductItemUrlWithVariant(data)}?variant=${variantId}`);
    } else {
      const variantParam = selectedVariant ? `?variant=${selectedVariant.id}` : '';
      const redirectParam = redirectProductToSpecificVariant ? `?variant=${redirectProductToSpecificVariant}` : '';
      itemHtml = itemHtml.replace(/{{itemUrl}}/g, `${Utils.buildProductItemUrlWithVariant(data)}${variantParam}${redirectParam}`);
    }

    localStorage.setItem('scrollToTop', 'true');

    // Compile additional variables if functions are available
    if (typeof Utils.compileShopifyProductVariables === 'function') itemHtml = Utils.compileShopifyProductVariables(data, itemHtml);
    if (typeof Utils.compileShopifyProductMetafield === 'function') itemHtml = Utils.compileShopifyProductMetafield(data, itemHtml);

    // Adjust classes based on screen size
    const windowSize = jQ(window).width();
    if (windowSize > 1239 && index % 4 === 0) {
      itemHtml = itemHtml.replace(/Grid__Cell/g, 'Grid__Cell');
    } else if (windowSize > 640 && windowSize <= 1239 && index % 3 === 0) {
      itemHtml = itemHtml.replace(/Grid__Cell/g, 'Grid__Cell');
    } else if (windowSize <= 640 && index % 2 === 0) {
      itemHtml = itemHtml.replace(/Grid__Cell/g, 'Grid__Cell');
    }
    // Return empty string if product is tagged to be hidden from search, otherwise return HTML
    // return data.tags.includes("hide-from-search") ? '' : itemHtml;
    
    // ✅ Smarter hide logic — works correctly for rose-gold and similar variant tags
    const shouldHideProduct = (() => {
      const params = new URLSearchParams(window.location.search);
      const metals = [];
      const sizes = [];

      params.forEach((value, key) => {
        if (key === 'pf_opt_metal') metals.push(value.toLowerCase());
        if (key === 'pf_opt_size') sizes.push(value.toLowerCase());
      });

      if (data.tags.includes("hide-from-search")) return true;

      const variants = data.variants || [];

      const visibleVariants = variants.filter(variant => {
        const available = variant.available === true;

        const metal =
        (variant.option_metal || getMergedOption(variant, "metal") || "").toLowerCase();
        const size =
        (variant.option_size || getMergedOption(variant, "size") || "").toLowerCase();
        
        // Hide sold-out sizes if tag present
        if (data.tags.includes("hide-sold-out-sizes") && !available) return false;
        
        // Hide .25/.75 fractional sizes
        if (
          data.tags.includes("hide-.25-.75-size-options") &&
          size &&
          (() => {
            const num = parseFloat(size);
            const decimal = num % 1;
            return decimal === 0.25 || decimal === 0.75;
          })()
        ) return false;

        // ----------------
        // HIDE SIZE OPTION
        // ----------------

        // helper to normalize strings (fixes case + space issues)
        function normalizeString(str) {
          return String(str)
            .trim()
            .toLowerCase();
        }

        // collect hidden sizes from product tags
        const hiddenSizes = data.tags
          .filter(tag => tag.includes('hide-size-option:'))
          .map(tag =>
            normalizeString(tag.split('hide-size-option:')[1])
          );

        // normalize sizes array
        const normalizedSizes = sizes.map(size => normalizeString(size));

        // check if any size should be hidden
        const hasHiddenSize = normalizedSizes.some(size =>
          hiddenSizes.includes(size)
        );

        // if hidden size exists → stop rendering
        if (hasHiddenSize) return false;

        // Hide metal-based variants
        if (data.tags.includes("hide-rose-gold-variants") && metal.includes("rose gold")) return false;
        if (data.tags.includes("hide-yellow-gold") && metal.includes("yellow gold")) return false;
        if (data.tags.includes("hide-white-gold") && metal.includes("white gold")) return false;
        if (data.tags.includes("hide-platinum") && metal.includes("platinum")) return false;
        if (data.tags.includes("hide-idkms-option") && size.includes("i don't know my size; send me a ring sizing gauge!")) return false;

        // If a filter is applied, ensure variant matches it
        if (metals.length > 0 && !metals.some(m => metal.includes(m))) return false;
        if (sizes.length > 0 && !sizes.some(s => size.includes(s))) return false;

        // Variant is visible if it reaches here
        return true;
      });

      // Hide the product only if no valid variants remain
      return visibleVariants.length === 0;

      // Helper to extract merged options (handles Boost variant data)
      function getMergedOption(variant, key) {
        if (!variant.merged_options) return "";
        const match = variant.merged_options.find(opt =>
          opt.toLowerCase().startsWith(`${key}:`)
        );
        return match ? match.split(":")[1].trim() : "";
      }
    })();
    
    if (shouldHideProduct) {
      itemHtml = itemHtml.replace(
        /<div class="([^"]*Grid__Cell[^"]*)"/,
        '<div class="$1 ProductItemHidden"'
      );
    }

    if (promoTileHtml) {
      return promoTileHtml + itemHtml;
    }
    return itemHtml;
  };
  /************************** END BUILD PRODUCT LIST **************************/

  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
  function buildClass() {
    return boostPFSThemeConfig.custom.filter_position == 'drawer' ? 'lap-and-up' : 'desk';
  }

  function buildClassHiz() {
    return boostPFSThemeConfig.custom.use_horizontal ? 'ProductItem--horizontal' : '';
  }

  function buildButtonSecond() {
    return boostPFSThemeConfig.custom.use_horizontal ? '<a href="{{itemUrl}}" class="ProductItem__ViewButton Button Button--secondary hidden-pocket">' + boostPFSThemeConfig.label.view_product + '</a>' : '';
  }
  var datainx =-1;
  function buildImage(data, images) {
    var fetchpriority = 'low';
    var fetchloading = 'lazy';
    var mainImages = data.images_info;
    var isMobile = $(window).width() < 768;  // Detect mobile viewport
    var mobileFirstImage = null
    var mobileSecondImage = null
    var htmlImg = '';

    itemUrl = "{{itemUrl}}"

    if (typeof (images[0]) == 'undefined') images = data.images_info;

    if (typeof (images) !== 'undefined' && images.length > 0) {
      htmlImg += '<a href="' + itemUrl + '" class="xs-hidden ProductItem__ImageWrapper ';
      if (isMobile) { htmlImg += 'hide ';}  // Add hide class for Mobile
      var use_natural_size = false;
      var has_alternate_image = false;
      if (boostPFSThemeConfig.custom.product_image_size == 'natural' || boostPFSThemeConfig.custom.use_horizontal)
        use_natural_size = true;
      if (boostPFSThemeConfig.custom.product_show_secondary_image && images.length > 1 && !boostPFSThemeConfig.custom.use_horizontal)
        has_alternate_image = true;
      if (has_alternate_image)
        htmlImg += 'ProductItem__ImageWrapper--withAlternateImage';
        // Close class attribute and conditionally add inline style for mobile
        htmlImg += '"' + (isMobile ? ' style="display:none !important;"' : '') + '>';
      var max_width = images[0].width;
      if (boostPFSThemeConfig.custom.use_horizontal) max_width = 125;
      var withCall = use_natural_size ? 'withFallback' : boostPFSThemeConfig.custom.product_image_size;
      htmlImg += '<div class="AspectRatio AspectRatio--' + withCall + '" style="max-width: ' + max_width + 'px;';
      var aspect_ratio = images[0].width / images[0].height;
      if (use_natural_size) {
        htmlImg += 'padding-bottom: ' + (100 / aspect_ratio) + '%;';
      }
      htmlImg += ' --aspect-ratio: ' + aspect_ratio + '">';
      if (has_alternate_image && images.length > 1) {
        /* Grabbing Custom Image for Collections Product Hover(Second Image) */
        var defaultHoverImage = Utils.getProductMetafield(data, 'custom', 'collection_hover_image')
        var sizes = '320, 480, 768, 1024'
        var support_size = imageSize(sizes, images[1]);
        var thumbUrl = Utils.optimizeImage(images[1]['src'], '{width}x');

        /* Setting Custom Image on Collections Product Hover(Second Image) */
        if (defaultHoverImage && defaultHoverImage !== null && defaultHoverImage !== '') {
          htmlImg += '<img class="ProductItem__Image ProductItem__Image--alternate Image--lazyLoad"  data-src="' + defaultHoverImage + '" data-sizes="auto" alt="' + data.title + '" data-image-id="' + images[1].id + '">';
          mobileSecondImage = '<img onclick="document.location=' + `'${itemUrl}'` + ';return false;" class="carousel-cell-image" alt="' + data.title + '" data-image-id="' + images[1].id + '" src="' + defaultHoverImage + '" >';
        } else {
          htmlImg += '<img class="ProductItem__Image ProductItem__Image--alternate Image--lazyLoad"  data-src="' + thumbUrl + '" data-widths="[' + support_size + ']" data-sizes="auto" alt="' + data.title + '" data-image-id="' + images[1].id + '">';
          // On mobile show slider with small image
          mobileSecondImage = '<img onclick="document.location=' + `'${itemUrl}'` + ';return false;"  class="carousel-cell-image" alt="' + data.title + '" data-image-id="' + images[1].id + '" src="' + thumbUrl.replace('{width}', '450') + '">';
        }
      }

      var sizes_main = '320, 480, 768, 1024'
      /* Calling function to grab first image of product grid: Collection */
      var support_size = imageSize(sizes_main, images[0]);
      /* Setting up custom default image for the product using metafield */
      var thumbUrl_main = updateCurrentdefaultImage(data);
     
      // Responsive srcset
      var srcset = 
        thumbUrl_main.replace('{width}', '320') + ' 320w, ' +
        thumbUrl_main.replace('{width}', '480') + ' 480w, ' +
        thumbUrl_main.replace('{width}', '768') + ' 768w, ' +
        thumbUrl_main.replace('{width}', '1024') + ' 1024w';
          htmlImg += '<img onclick="document.location=\'' + itemUrl + '\';return false;" ' +
                  'class="ProductItem__Image imgfade" ' +
                  'src="' + thumbUrl_main.replace('{width}', '600') + '" ' +
                  'fetchpriority="' + fetchpriority + '" decoding="async" loading="' + fetchloading + '"' +
                  'srcset="' + srcset + '" ' +
                  'sizes="(max-width: 768px) 100vw, 25vw" ' +
                  'alt="' + data.title + '" data-image-id="' + images[0].id + '">';
          // Mobile slider image (keep smaller src)
          mobileFirstImage = '<img onclick="document.location=\'' + itemUrl + '\';return false;" ' +
                            'class="carousel-cell-image imgfade" ' +
                            'alt="' + data.title + '" ' +
                            'fetchpriority="' + fetchpriority + '" decoding="async" loading="' + fetchloading + '"' +
                            'data-image-id="' + images[0].id + '" ' +
                            'src="' + thumbUrl_main.replace('{width}', '450') + '">';
      // Noscript fallback
      htmlImg += '<noscript>';
      htmlImg += '<img class="ProductItem__Image ProductItem__Image--alternate" ' +
                'src="' + Utils.optimizeImage(images[0]["src"], "600x") + '" alt="' + data.title + '">';
      htmlImg += '<img class="ProductItem__Image" ' +
                'src="' + Utils.optimizeImage(images[0]["src"], "600x") + '" alt="' + data.title + '">';
      htmlImg += '</noscript>';
      htmlImg += '</div>';
      htmlImg += '</a>';

      htmlImg += '<div class="collection-product-slider-mobile ProductList__Slider ">';
      htmlImg += '<div class="js-flickity carousel mobileslider MobSlider' + data.id + '" data-flickity="{fullscreen: true, pageDots: true, prevNextButtons: false, lazyLoad: 1, initialIndex: 0, wrapAround: true}">';
      if (mobileFirstImage) {
        htmlImg += '<div class="carousel-cell">';
        htmlImg += '<div class="carousel-cell-image-wrapper">';
        htmlImg += mobileFirstImage;
        htmlImg += '</div>';
        htmlImg += '</div>';
      }
      if (mobileSecondImage && window.innerWidth < 768) {
        /* Showing first four images instead of One on Mobile Device */
        images.slice(1, 4).forEach(function(image, index) {
          const imageUrl = image.src || image.url;
          const thumb = Utils.optimizeImage(imageUrl, '450x');

          htmlImg += '<div class="carousel-cell">';
          htmlImg += '<div class="carousel-cell-image-wrapper">';
          htmlImg += '<img onclick="document.location=\'' + itemUrl + '\';return false;" ' +
                    'class="carousel-cell-image imgfade" ' +
                    'alt="' + data.title + '" ' +
                    'data-image-id="' + image.id + '" ' +
                    'src="' + thumb + '">';
          htmlImg += '</div>';
          htmlImg += '</div>';
        });
      }
      htmlImg += '</div>';
      htmlImg += '</div>';
    }
    return htmlImg;
  }

  function updateCurrentdefaultImage(data) {
    var images = data.images_info;
    var defaultImage = images.length > 0
      ? Utils.optimizeImage(images[0]['src'], '{width}x')
      : boostPFSAppConfig.general.no_image_url;
    var defaultImageCollectionSearch = Utils.getProductMetafield(data, 'custom', 'default_image_for_collection_and_search');
    var selectedMetal = Utils.getParam('pf_opt_metal');

    var collectionMetafields = [
      { id: 'collection_1_name', image: 'collection_1_default_img' },
      { id: 'collection_2_name', image: 'collection_2_default_image' },
      { id: 'collection_3_name', image: 'collection_3_default_image' },
      { id: 'collection_4_name', image: 'coll_4_d_image' },
      { id: 'collection_5_name', image: 'collection_5_default_image' },
    ];

    for (var { id, image } of collectionMetafields) {
      var collectionName = Utils.getProductMetafield(data, 'custom', id);
      var defaultImageForCollection = Utils.getProductMetafield(data, 'custom', image);
      if (currentCollectionId === collectionName && defaultImageForCollection && selectedMetal == null) return defaultImageForCollection.trim();
    }
    
    if (defaultImageCollectionSearch && selectedMetal == null) return defaultImageCollectionSearch.trim();
    return defaultImage;
  }

  function imageSize(sizes, image) {
    if (!image) return '';
    let supportedSizes = '';
    const desiredSizes = sizes.split(',');
    for (let i = 0; i < desiredSizes.length; i++) {
      const size = parseInt(desiredSizes[i], 10);
      if (image.width < size) break; // Stop if the desired size exceeds the image width
      supportedSizes += size + ','; // Append the valid size to supportedSizes
    }
    return supportedSizes ? supportedSizes.slice(0, -1) : image.width.toString(); // Remove trailing comma if supportedSizes is not empty
  }

  function buildPrice(data) {
    var html = '';
    var showPriceStatus = boostPFSFilterConfig.general.getCollectionPriceStatus
    // var textBeforePrice = Utils.getProductMetafield(data, 'custom', 'text_before_price') ? 'From' : "";
    var textBeforePrice = (data?.price_max > data?.price_min) ? prefixOfPrice : '';
    /* Hiding price for collection Using metafield */
    if (showPriceStatus == null || !showPriceStatus || showPriceStatus === "false") {
      var show_price_on_hover = boostPFSThemeConfig.custom.product_show_price_on_hover;
      var classPriceHover = show_price_on_hover ? 'ProductItem__PriceList--showOnHover' : '';
      var PriceToShow = Utils.formatMoney(data.price_min);
      var lowestAvailableVariant = $(data.variants).filter(function () {
        return this.available === true;
      }).sort(function (a, b) {
        return a.price - b.price;
      })[0];
      if(data.tags.includes("hide-sold-out-sizes")) PriceToShow = Utils.formatMoney(lowestAvailableVariant?.price);
      if (PriceToShow.includes(".00")) PriceToShow = PriceToShow.replace(".00", "");
      html += '<div class="ProductItem__PriceList ' + classPriceHover + ' Heading">';
      if (onSale) {
        html += '<span class="ProductItem__Price Price Price--highlight Text--subdued" style="color:#B20B0B" data-money-convertible>' + textBeforePrice + ' ' + PriceToShow + '</span> ';
      } else {
        if (priceVaries) {
          var moneyPrice = Utils.formatMoney(data.price_min)
          if (moneyPrice.includes(".00")) moneyPrice = moneyPrice.replace(".00", "")
          html += '<span class="ProductItem__Price Price Price--highlight Text--subdued">' + textBeforePrice + ' ' + moneyPrice + '</span>';
        } else {
          var moneyPrice = Utils.formatMoney(data.price_min)
          if (moneyPrice.includes(".00")) moneyPrice = moneyPrice.replace(".00", "")
          if (textBeforePrice && textBeforePrice != null) {
            html += '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' + textBeforePrice + ' ' + moneyPrice + '</span>';
          } else {
            html += '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' + moneyPrice + '</span>';
          }
        }
      }
    }
    html += '</div>';
    return html;
  }

  function buildLabels(data) {
    var html = '';
    var product_labels = '';
    if (boostPFSThemeConfig.custom.show_labels) {
      product_labels = '';
      var tags = data.tags;
      for (var k = 0; k < tags.length; k++) {
        var tag = tags[k];
        if (tag.indexOf('__label') != -1) {
          product_labels += '<span class="ProductItem__Label Heading Text--subdued">' + tag.split('__label:')[1] + '</span>';
          break;
        }
      }
      if (!soldOut) {
        if (onSale) product_labels += '<span class="ProductItem__Label Heading Text--subdued">' + boostPFSThemeConfig.label.sale + '</span>';
      } else {
        product_labels += ' <span class="ProductItem__Label Heading Text--subdued">' + boostPFSThemeConfig.label.sold_out + '</span>';
      }
      if (product_labels != '') {
        html += '<div class="ProductItem__LabelList">';
        html += product_labels;
        html += '</div>';
      }
    }
    return html;
  }

  function buildInfo(data, indx) {
    var html = '';
    if (boostPFSThemeConfig.custom.show_product_info) {
      var infoClass = (!boostPFSThemeConfig.custom.use_horizontal) ? 'ProductItem__Info--' + boostPFSThemeConfig.custom.product_info_alignment : '';
      html += '<div class="ProductItem__Info ' + infoClass + ' ">';
      if (boostPFSThemeConfig.custom.show_vendor) html += '<p class="ProductItem__Vendor Heading">' + data.vendor + '</p>';
      html += '<div class="ProductItem__Container ProductItemCard">';
      // Product Title
      html += '<div class="ProductItemTop">';
      html += '<h2 class="ProductItem__Title Heading">';
      html += '<a href="{{itemUrl}}">' + data.title + '</a>';
      html += '</h2>';
      html += buildPrice(data);
      html += '</div>';
      html += '<div class="ProductItemBottom">';
      // Yotpo Widget Instance Integration
      html += '<div class="yotpo-widget-instance yotpo-collection-widget" data-yotpo-instance-id="370154" ';
      html += 'data-yotpo-product-id="' + data.id + '"'; // Assuming 'data.id' is the product ID
      html += 'data-yotpo-cart-product-id="' + data.id + '"'; // Assuming same ID applies
      html += 'data-yotpo-section-id="shopify-section-template--17136324870232__yotpo_review_widget_3_4zQWRY"'; // Assuming template name is accessible via boostPFSThemeConfig
      html += '></div>';
      // if (boostPFSThemeConfig.custom.show_color_swatch) {
      html += buildSwatch(data, indx);
      // }
      html += '</div>';
      html += '</div>';
    }
    if (data.template_suffix == "hide.and.redirect") {
      return '';
    } else {
      // setTimeout(function () {
        $('.yotpo-sr-star-full svg').attr('tabindex', '-1')
        $('.yotpo-sr-bottom-line-right-panel .yotpo-sr-bottom-line-text--right-panel').attr('tabindex', '-1')
      // },800)
      return html;
    }
  }

  /* Mobile Filter */
  function mobileFilter() {
    $('.boost-pfs-check-box').click(function () {
      $(this).closest('.boost-pfs-filter-option').removeClass("boost-pfs-filter-option-collapsed");
      $(this).find('.boost-pfs-filter-option-content').removeClass("toggled");
    })
    $(".boost-pfs-filter-option").click(function () {
      if ($(this).hasClass('boost-pfs-filter-option-collapsed')) {
        $(this).addClass('boost-pfs-filter-option-collapsed')
        $(this).find(".boost-pfs-filter-option-content").addClass("toggled")
      } else {
        $(this).removeClass('boost-pfs-filter-option-collapsed')
        $(this).find(".boost-pfs-filter-option-content").removeClass("toggled")
      }
    })
  }

  function buildSwatch(data, indx) {
    var itemSwatchHtml = '';
    if (true) {
      var color_name = boostPFSThemeConfig.custom.section_id + '-' + data.id + '-' + indx;
      data.options_with_values.forEach(function (option, index) {
        var option_name = option.name.toLowerCase();
        if (option_name.indexOf('metal') != -1 && option_name.indexOf('outer') == -1) {
          var values = '';
          itemSwatchHtml += '<div class="ProductItem__ColorSwatchList">';
          var i = 0;
          data.variants.forEach(function (variant) {
            var temp = variant.merged_options.filter(function (obj) {
              obj = obj.toLowerCase();
              if (obj.indexOf('metal') != -1 || obj.indexOf('color') != -1 || obj.indexOf('colour') != -1 || obj.indexOf('couleur') != -1)
                return obj;
            });
            temp = temp[0].split(':');

            var value = temp[1].toLowerCase();
            var hideRoseGold = value == '14k rose gold' && data.tags.includes('hide-rose-gold-variants');

            if (values.indexOf(value) == -1 && !hideRoseGold) {
              values = values + ',' + value;
              values = values.split(',');
              var size = '320, 480, 768, 1024';
              var supported_sizes = imageSize(size, variant.image);
              var color_image = Utils.optimizeImage(variant.image);
              var name_color = Utils.slugify(value) + '.png';
              var checked = (i == 0) ? 'checked=checked' : '';
              var imageInfo = null;
              var image_aspect_ratio = 1;
              imageInfo = data.images_info.find(function (imageOb) {
                if (imageOb.src == variant.image) {
                  image_aspect_ratio = imageOb.width / imageOb.height;
                  return imageOb;
                }
              });
              if (!imageInfo) {
                if (data.images_info.length > 0) {
                  imageInfo = data.images_info[0];
                } else {
                  imageInfo = {
                    src: boostPFSConfig.general.no_image_url,
                    id: variant.id,
                    width: 480,
                    height: 480
                  }
                }
              }
              var dataImg = (imageInfo != null) ? '" data-image-url="' + imageInfo.src + '" data-image-widths="[' + supported_sizes + ']" data-image-aspect-ratio="1" data-image-id="' + imageInfo.id + '"' : '';
              var color_input_id = color_name + "-" + values.length;
              var variant_price = variant.price ? variant.price : 0;
              var variant_compare_at_price = variant.compare_at_price ? variant.compare_at_price : 0;
              var url_color = Utils.getFilePath(Utils.slugify(value), Globals.swatchExtension, Settings.getSettingValue('general.swatchImageVersion'));
              itemSwatchHtml += '<div class="ProductItem__ColorSwatchItem">';
              itemSwatchHtml += '<input class="ColorSwatch__Radio" type="radio" ' + checked + ' name="' + color_name + '" id="' + color_input_id + '" value="' + value + '" data-image-aspect-ratio="' + image_aspect_ratio + '" data-variant-price="' + variant_price + '" data-variant-compare-at-price="' + variant_compare_at_price + '" data-variant-url="' + Utils.buildProductItemUrlWithVariant(data) + '?variant=' + variant.id + '#Image' + imageInfo.id + '"' + dataImg + '  aria-hidden="true">';
              itemSwatchHtml += '<label class="ColorSwatch ColorSwatch--small  ColorSwatch--circle" for="' + color_input_id + '" style="background-color: ' + value.replace(' ', '').toLowerCase() + '; background-image: url(' + url_color + ')" title="' + value.replace(/\b\w/g, char => char.toUpperCase()) + '" data-tooltip="' + value.replace(/\b\w/g, char => char.toUpperCase()) + '"><span class="active-border"></span></label>';
              itemSwatchHtml += '</div>';
              i++;
            }
          });
          itemSwatchHtml += '</div>';
        }
      });
    }
    return itemSwatchHtml;
  }
  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/

  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (totalPage > 1) {
      var paginationHtml = boostPFSTemplate.paginateHtml;
      // Build Previous
      var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
      // Build Next
      var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
      // Create page items array
      var beforeCurrentPageArr = [];
      for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) beforeCurrentPageArr.unshift('...');
      if (currentPage - 4 >= 0) beforeCurrentPageArr.unshift(1);
      
      beforeCurrentPageArr.push(currentPage);
      var afterCurrentPageArr = [];
      
      for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) afterCurrentPageArr.push('...');
      if (currentPage + 3 <= totalPage)  afterCurrentPageArr.push(totalPage);
      
      // Build page items
      var pageItemsHtml = '';
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        (pageArr[iPage] == '...') ? pageItemsHtml += boostPFSTemplate.pageItemRemainHtml : (pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml);
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      return paginationHtml;
    }
    return '';
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = '';
    if (boostPFSThemeConfig.custom.show_sorting && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        // Build content
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          var classActive = (Globals.queryParams.sort == k) ? 'is-selected' : '';
          sortingItemsHtml += '<button class="Popover__Value ' + classActive + ' Heading Link Link--primary u-h6" data-value="' + k + '">' + sortingArr[k] + '</button>';
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      }
    }
    return html;
  };

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function () {
    var topSortingSelector = jQ(Selector.topSorting);
    if(parseInt(currentCollectionId) !== 267456807000){
      topSortingSelector.find('.Popover__Value').filter(function() {
        return $(this).attr('data-value') === 'number-extra-sort1-descending' ||
               $(this).attr('data-value') === 'number-extra-sort1-ascending';
      }).hide();
    }
    topSortingSelector.find('.Popover__Value').click(function (e) {
      FilterApi.setParam('sort', jQ(this).data('value'));
      FilterApi.setParam('page', 1);
      FilterApi.applyFilter('sort');
      jQ('.CollectionToolbar__Item--sort').trigger('click');
    });

    // Reinitializing the flickity slider on buildSortingEvent
    console.log("========== Reinitializing the flickity slider on buildSortingEvent =================")

    if (typeof yotpoWidgetsContainer !== 'undefined' && yotpoWidgetsContainer && typeof yotpoWidgetsContainer.initWidgets === 'function') yotpoWidgetsContainer.initWidgets(false);

    renderListBreakerComp(Globals)
    renderStaticImgShopTheLook(Globals)
    mobileFilter();
    reInitializeFlickityAfterSearch();

    // Dual Focus Control on Filters  
    $('.boost-pfs-filter-button').on('keypress click focus', function () {
      const checkboxBoostAttr = $('.boost-pfs-filter-options-wrapper')
        .find('.boost-pfs-filter-option-list')
        .find('.boost-pfs-filter-option-content')
        .find('.boost-pfs-filter-option-item-list-multiple-list')
        .find('li, button, span')
        .find('.boost-pfs-check-box');
      for (let i = 0; i < checkboxBoostAttr.length; i++) {
        $(checkboxBoostAttr[i]).attr('tabindex', '-1').removeAttr('role');
      }
    });
  }
  /************************** END BUILD TOOLBAR **************************/

  /* Function to find the value of a specific metafield key */
  function getMetafieldValue(metafields, targetKey, targetId) {
  const values = metafields
    .filter(item => item.key === targetKey && item.id === targetId)
    .map(item => {
      try {
        const parsed = JSON.parse(item.value);
        return parseFloat(parsed.amount);
      } catch (e) {
        return null;
      }
    })
    .filter(val => !isNaN(val)); // Remove any nulls or NaNs from JSON parse failures
  return values.length > 0 ? Math.min(...values) : null; 
}


  /* Add additional feature for product list, used commonly in customizing product list */
  ProductList.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;
    array = [];
    /* Integrating sale price for products */
    for (var i = 0; i < data.length; i++) {
      var getSmallestPrice = [];
      var targetObject = data[i].metafields.find(item => item.key === "custom_starting_at_slash_variant_id");
      var savingsVerbiageText = data[i].metafields.find(item => item.key === "text_after_price_compare_at_");
      savingsVerbiageText ? savingsVerbiageText = savingsVerbiageText.value : ''
      var lowestAvailableVariant = $(data[i].variants).filter(function () {
        return this.available === true;
      }).sort(function (a, b) {
        return a.price - b.price;
      })[0];
      var minVariantId = targetObject ? Number(targetObject.value) : (data[i].tags.includes("hide-sold-out-sizes") ? lowestAvailableVariant?.id : data[i].variants[0].id);
      var minVariantPrice = $.grep(data[i].variants, function (obj) {
        return obj.id === minVariantId;
      });
      var minPrice = minVariantPrice ? minVariantPrice[0]?.price : data[i].variants[0]?.price;
      for (var j = 0; j < data[i].variants.length; j++) {
        var variant = data[i].variants[j];
        if (variant.inventory_quantity > 0) {
          var variantDetails = {
            variantId: variant.id,
            price: variant.price
          };
          getSmallestPrice.push(variantDetails);
          if (variant.price < minPrice) {
            minPrice = variant.price;
            minVariantId = targetObject ? Number(targetObject.value) : variant.id;
          }
        }
      }
      if (data[i].tags.includes("hide-from-search") === false) {
        var productDetails = {
          getMetaData: data[i].metafields,
          getCompareAt: data[i].tags.includes("hide-sold-out-sizes") ? lowestAvailableVariant?.compare_at_price : data[i].compare_at_price_min,
          getVariantId: minVariantId,
          getProductId: data[i].id,
          getVariantPrice: minPrice,
          getSavingsVerbiageText: savingsVerbiageText,
          showCompareAtPercentOff: data[i].tags.includes("hide-compare-at-percent")
        }
        array.push(productDetails);
      }
    }
    $(".ProductListWrapper").find(".Grid__Cell").each(function (i) {
      const variantId = array[i]?.getVariantId;
      if (variantId !== undefined) {
        $(this).find(".ProductItem__PriceList.Heading").addClass(JSON.stringify(variantId));
      }
    });

    for (var j = 0; j < array.length; j++) {
      var regPrice = parseFloat(array[j].getVariantPrice);
      var compareAtPrice = array[j].getCompareAt ? parseFloat(array[j].getCompareAt) : "";
      var savingsVerbiage = array[j].getSavingsVerbiageText ? array[j].getSavingsVerbiageText : "";
      var grabSavingsVerbiageColor = savingsVerbiageColor ? savingsVerbiageColor : salePriceColorGlobal
      var vipPrice = getMetafieldValue(array[j].getMetaData, "vip_price_sale_currency", array[j].getVariantId) ? parseFloat(getMetafieldValue(array[j].getMetaData, "vip_price_sale_currency", array[j].getVariantId)) : 0;
      var vvipPrice = getMetafieldValue(array[j].getMetaData, "vvip_price_sale_currency", array[j].getVariantId) ? parseFloat(getMetafieldValue(array[j].getMetaData, "vvip_price_sale_currency", array[j].getVariantId)) : 0;
      var checkVisitingCustomer = localStorage.getItem("setVisitingCustomer");
      var checkVisitingCustomerPrivateSale = localStorage.getItem("setVisitingCustomerPrivateSale");
      var salePrice = 0;
      var showPercentOff = false;
      var enableCompareAtPrice = false;

      /* Appending data attribute for Price: Intelligems */
      $('.ProductItem__PriceList.' + array[j].getVariantId + ' .money').attr('data-variant-id', array[j].getVariantId);

      /* Grab Regular Price through 'From' */
      var grabUpdatedRegPrice = $('.ProductItem__PriceList.' + array[j].getVariantId + ' .money').attr('data-variant-id', array[j].getVariantId).text();
      if (grabUpdatedRegPrice && grabUpdatedRegPrice !== '') {
        var removeDollarComma = parseFloat(grabUpdatedRegPrice.replace(/[\$,]/g, ''));
        regPrice = removeDollarComma.toFixed(2);
      }

      /* Sale Price for All Visitors */
      if (showSalePriceGlobal) {
        salePrice = getMetafieldValue(array[j].getMetaData, "custom_sale_price_currency", array[j].getVariantId) ? parseFloat(getMetafieldValue(array[j].getMetaData, "custom_sale_price_currency", array[j].getVariantId)) : 0;
        showPercentOff = enableCompareAtPrice = true;
      }
      /* Sale Price to show for VIP Visitors */
      if (showVIPPriceGlobal && checkVisitingCustomer && checkVisitingCustomer === getVIPParam) {
        salePrice = vipPrice;
        showPercentOff = enableCompareAtPrice = true;
      }
      /* Sale Price to show for VVIP Visitors */
      if (showVVIPPriceGlobal && checkVisitingCustomer && checkVisitingCustomer === getVVIPParam) {
        salePrice = vvipPrice;
        showPercentOff = enableCompareAtPrice = true;
      }
      /* Locked Private Sale: Sale Price to show for VIP Visitors */
      if (showVIPPrivateSale && checkVIPUser && checkVisitingCustomerPrivateSale && checkVisitingCustomerPrivateSale === getVIPParamPrivateSale) {
        salePrice = vipPrice;
        showPercentOff = enableCompareAtPrice = true;
      }
      /* Locked Private Sale: Sale Price to show for VVIP Visitors */
      if (showVVIPPrivateSale && checkVVIPUser && checkVisitingCustomerPrivateSale && checkVisitingCustomerPrivateSale === getVVIPParamPrivateSale) {
        salePrice = vvipPrice;
        showPercentOff = enableCompareAtPrice = true;
      }
      if (compareAtPrice && compareAtPrice != null && compareAtPrice > 0 && compareAtPrice > regPrice) enableCompareAtPrice = true
      
      /* Format Prices */
      var formattedSalePrice = formatPriceFunc(salePrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })); /* Removing decimal if .00 found in the price */
      var formattedCompareAtPrice = formatPriceFunc(compareAtPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })); /* Removing decimal if .00 found in the price */

      /* Calculate Percentage Off */
      var percentageOff = '';
      if (showPercentOff) {
        percentageOff = (((regPrice - salePrice) / regPrice) * 100).toFixed(2).replace(/\.00$/, '') + "% Off";
      }
      /* Compare At Percentage Off */
      if (compareAtPrice && compareAtPrice != null && compareAtPrice > 0 && compareAtPrice > regPrice && enableCompareAtPrice == true && array[j].showCompareAtPercentOff !== true) {
        percentageOff = (((compareAtPrice - regPrice) / compareAtPrice) * 100).toFixed(2).replace(/\.00$/, '') + "% Off";
      }
      if ((salePrice != '' && salePrice > 0) || (compareAtPrice != null && parseFloat(compareAtPrice) > 0)) {
        if (compareAtPrice && compareAtPrice > regPrice) {
          var startingTextFound = $(".ProductItem__PriceList.Heading." + array[j].getVariantId).find(".ProductItem__Price.Price.Price--highlight.Text--subdued").text().includes(prefixOfPrice+" ");
          if (startingTextFound) {
            var removedStartingAtText = $(".ProductItem__PriceList.Heading." + array[j].getVariantId).find(".ProductItem__Price.Price.Price--highlight.Text--subdued").text().replace(prefixOfPrice+" ", "");
            $(".ProductItem__PriceList.Heading." + array[j].getVariantId).find(".ProductItem__Price.Price.Price--highlight.Text--subdued").text(removedStartingAtText);
          }
          if ($(".ProductItem__PriceList.Heading." + array[j].getVariantId).find("span.ProductItem__Price.strikeThrough").length === 0) {
            $(".ProductItem__PriceList.Heading." + array[j].getVariantId).append('<div class="alignText">' + (startingTextFound === true ? "<span class='starting-at' style='margin-right: 4px;'>"+prefixOfPrice+" </span>" : '') + '<span class="ProductItem__Price Price Text--subdued strikeThrough" data-money-convertible="" style="display:inline-block;"><span class="money">$' + formattedCompareAtPrice + '</span></span>' + (savingsVerbiage && savingsVerbiage !== '' && percentageOff && !array[j].showCompareAtPercentOff === '' ? '<span class="savings-verbiage-text" style="color: ' + grabSavingsVerbiageColor + '"> ' + savingsVerbiage + ' </span>' : '') + (enableCompareAtPrice && !array[j].showCompareAtPercentOff ? '<span id="' + array[j].getVariantId + '_percentOff" style="margin-left:5px;color:' + showPercentageOffColorGlobal + '"> ' + percentageOff + '</span>' : '') + '</div>');
          } else {
            $(".ProductItem__PriceList.Heading." + array[j].getVariantId).find("span.money" > '$' + formattedCompareAtPrice);
          }
          var checkMoneyHTML = $(".ProductItem__PriceList.Heading." + array[j].getVariantId).addClass("textUpword-collection").find("span.money").length
          if (checkMoneyHTML === 2) {
            $(".ProductItem__PriceList.Heading." + array[j].getVariantId).addClass("textUpword-collection").find("span.money").eq(0).css("color", salePriceColorGlobal);
          } else {
            $(".ProductItem__PriceList.Heading." + array[j].getVariantId).addClass("textUpword-collection").find("span.money").eq(1).css("color", salePriceColorGlobal);
          }
          if ($(".ProductItem__PriceList.Heading." + array[j].getVariantId).find("#" + array[j].getVariantId + "_percentOff").length !== 0) {
            $(".ProductItem__PriceList.Heading." + array[j].getVariantId).find("#" + array[j].getVariantId + "_percentOff").val("");
          }
          if ($(".ProductItem__PriceList.Heading." + array[j].getVariantId).find("span.ProductItem__Price.salePriceAppend.Text--subdued").length !== 0) {
            $(".ProductItem__PriceList.Heading." + array[j].getVariantId).find("span.money").remove();
          }
        } else {
          if (salePrice && salePrice < regPrice) {
            if ($(".ProductItem__PriceList.Heading." + array[j].getVariantId).find(".ProductItem__Price.Price.Text--subdued").find("span.money").find("span.money").eq(0).length !== 0) {
              $(".ProductItem__PriceList.Heading." + array[j].getVariantId).find(".ProductItem__Price.Price.Text--subdued").find("span.money").find("span.money").eq(0).addClass("strikeThrough");
            } else {
              $(".ProductItem__PriceList.Heading." + array[j].getVariantId).find(".ProductItem__Price.Price.Text--subdued").find("span.money").eq(0).addClass("strikeThrough");
            }
            if (showPercentOff && $(".ProductItem__PriceList.Heading." + array[j].getVariantId).find("#" + array[j].getVariantId + "_percentOff").length === 0) {
              $(".ProductItem__PriceList.Heading." + array[j].getVariantId).append("<span id='" + array[j].getVariantId + "_percentOff' style=color:" + showPercentageOffColorGlobal + "> " + percentageOff + "</span>");
            } else if (showPercentOff) {
              $(".ProductItem__PriceList.Heading." + array[j].getVariantId).find("#" + array[j].getVariantId + "_percentOff").val(percentageOff);
            }
            if ($(".ProductItem__PriceList.Heading." + array[j].getVariantId).find("span.ProductItem__Price.salePriceAppend.Text--subdued").length === 0) {
              $(".ProductItem__PriceList.Heading." + array[j].getVariantId).append('<span class="ProductItem__Price Price Text--subdued salePriceAppend" data-money-convertible="" style="display:block; color:' + salePriceColorGlobal + '"><span class="money">$' + formattedSalePrice + '</span></span>');
            } else {
              $(".ProductItem__PriceList.Heading." + array[j].getVariantId).find("span.money" > '$' + formattedSalePrice);
            }
            $(".ProductItem__PriceList.Heading." + array[j].getVariantId).removeClass("textUpword-collection")
            if ($(".ProductItem__PriceList.Heading." + array[j].getVariantId).find("span.ProductItem__Price.strikeThrough").length !== 0) {
              $(".ProductItem__PriceList.Heading." + array[j].getVariantId).find("span.money").remove();
            }
          }
        }
      }
    }

    // Flair
    if (typeof FlairApp !== 'undefined' && FlairApp) { FlairApp.refreshProductBadges(); }

    if (!eventType) eventType = this.eventType;

    // Fix image not load on Instagram browser - initialize swatch image
    jQ(".ProductItem__Info .ProductItem__ColorSwatchList .ProductItem__ColorSwatchItem label.ColorSwatch").click(function () {
      jQ(this).parent().parent().find('label.ColorSwatch').removeClass('active');
      jQ(this).addClass('active');
      var parent = jQ(this).parent();
      var productImage = jQ(this).parent().parent().parent().parent().find('a.ProductItem__ImageWrapper');
      var variantInfo = parent.find('input.ColorSwatch__Radio');
      productImage.find('.AspectRatio .bc-sf-product-swatch-img').remove();
      productImage.find('.AspectRatio').prepend('<img class="bc-sf-product-swatch-img" src="' + variantInfo.data('image-url') + '" />');
      productImage.find('img.ProductItem__Image').hide();
      productImage.attr('href', variantInfo.data('variant-url'));
    })

    //Change view layout
    var desktopView = $('.CollectionToolbar__LayoutSwitch.hidden-phone').find('.is-active').data('count');
    if (desktopView && desktopView !== parseInt(boostPFSThemeConfig.custom.desktop_row)) {
      $(Selector.products + ' .Grid__Cell').removeClass('1/' + boostPFSThemeConfig.custom.tablet_row + '--tablet-and-up 1/' + boostPFSThemeConfig.custom.desktop_row + '--' + buildClass());
      $(Selector.products + ' .Grid__Cell').addClass('1/' + desktopView + '--tablet-and-up 1/' + desktopView + '--' + buildClass());
    }
    var mobileView = $('.CollectionToolbar__LayoutSwitch.hidden-tablet-and-up').find('.is-active').data('count');
    if (mobileView && mobileView != parseInt(boostPFSThemeConfig.custom.mobile_row)) {
      $(Selector.products + ' .Grid__Cell').removeClass('1/' + boostPFSThemeConfig.custom.mobile_row + '--phone');
      $(Selector.products + ' .Grid__Cell').addClass('1/' + mobileView + '--phone');
    }
  };

  // Build additional elements
  Filter.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;
    if (!eventType) eventType = this.eventType;

    if (Utils.isSearchPage() && Globals.currentTerm == '') {
      var breadcrumbsText = $(".breadcrumbs-info").text();
      $(".breadcrumbs-info").text(breadcrumbsText.replace('""', ''));
    }

    handleInstockButton();

    if (data.total_product == 0) {
      $('.CollectionToolbar__Group .CollectionToolbar__Item--sort').hide();
      if (Utils.isMobile()) $('.CollectionToolbar__Group .CollectionToolbar__Item--filter').hide();
    } else {
      $('.CollectionToolbar__Group .CollectionToolbar__Item--sort').show();
      if (Utils.isMobile()) $('.CollectionToolbar__Group .CollectionToolbar__Item--filter').show();
    }

    if (Utils.isSearchPage()) {
      let currentSearchTerm = Utils.getSearchTerm();
      let searchCounterBreadcrumb = '';
      searchCounterBreadcrumb = `Search: ${data.total_product} result${data.total_product > 1 ? 's' : ''} found`;
      $('.breadcrumb').find('span').last().html(searchCounterBreadcrumb);
    }

    if (Utils.isMobile()) {
      var a = jQ('.boost-pfs-filter-products .Grid__Cell:nth-child(2) .ProductItemCard').outerHeight();
      var b = jQ('.boost-pfs-filter-products .Grid__Cell:nth-child(3) .ProductItemCard').outerHeight();
      jQ('.boost-pfs-filter-products .Grid__Cell').each(function(index){
        if (index == 0) {
          a = jQ('.boost-pfs-filter-products .Grid__Cell:nth-child(' + (index + 1 ) + ') .ProductItemCard').outerHeight();
          b = jQ('.boost-pfs-filter-products .Grid__Cell:nth-child(' + (index + 2) + ') .ProductItemCard').outerHeight();
        } else {
          a = jQ('.boost-pfs-filter-products .Grid__Cell:nth-child(' + (index) + ') .ProductItemCard').outerHeight();
          b = jQ('.boost-pfs-filter-products .Grid__Cell:nth-child(' + (index + 1) + ') .ProductItemCard').outerHeight();
        }
        
        if (index % 2 != 0) {
          var height = (a >= b) ? a : b;
          jQ('.boost-pfs-filter-products .Grid__Cell:nth-child(' + index + ') .ProductItemCard').attr('style', 'height: ' + height + 'px !important');
          jQ('.boost-pfs-filter-products .Grid__Cell:nth-child(' + (index + 1) + ') .ProductItemCard').attr('style', 'height: ' + height + 'px !important');
          
        }
        
      })
    }
  };

  // Handle instock button
  function handleInstockButton() {
    if (Object.keys(Globals.queryParams).includes('pf_st_only_see_in_stock')) {
      $('.in-stock-filter .slider').addClass('checked');
      $('.in-stock-toggle').prop('checked', true);
    }
    $(".in-stock-toggle").on('change', function () {
      if ($(this).is(":checked")) {
        $('.in-stock-filter .slider').addClass('checked');
        FilterApi.setParam('pf_st_only_see_in_stock', ['true']);
        FilterApi.setParam('page', 1);
        FilterApi.applyFilter('filter');
      } else {
        $('.in-stock-filter .slider').removeClass('checked');
        FilterApi.setParam('pf_st_only_see_in_stock', []);
        FilterApi.setParam('page', 1);
        FilterApi.applyFilter('filter');
      }
    });
  }
  FilterApi.beforeCall = function (eventType, eventInfo) {
    if (Object.keys(Globals.queryParams).includes('pf_st_only_see_in_stock')) {
      Globals.queryParams['product_available'] = true;
      Globals.queryParams['variant_available'] = true;
    }
    if (Shopify && Globals) {
      Globals.queryParams.currency = Shopify.currency.active;
      Globals.queryParams.currency_rate = Shopify.currency.rate;
      Globals.queryParams.country = Shopify.country;
      Globals.queryParams.return_all_currency_fields = false;
    }
  }
})()